import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import frCH from "./locales/fr-CH.json";
import en from "./locales/en.json";

export const SUPPORTED_LOCALES = [
  { code: "fr-CH", label: "Français (Suisse)" },
  { code: "en", label: "English" },
];

const stored = typeof window !== "undefined" ? window.localStorage.getItem("og_locale") : null;

i18n.use(initReactI18next).init({
  resources: { "fr-CH": { translation: frCH }, fr: { translation: frCH }, en: { translation: en } },
  lng: stored || "fr-CH",
  fallbackLng: "fr-CH",
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLocale(code) {
  window.localStorage.setItem("og_locale", code);
  i18n.changeLanguage(code);
}

export default i18n;
